<template>
  <div class="row text-start">
    <div class="product-item card col-md-12 faulty">
      <div class="card-body">
        <div class="row col-md-12">
          <div v-if="productData && productData.length > 0">
            <div>
              Error occured when parsing data for the following products:
            </div>
            <div>
              <ul>
                <li v-for="(product, index) in productData" :key="index">
                  {{ product.customerProductNumber }},
                  {{ product.customerProductName }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-facing-decorator";
import { ProductInformation } from "@/data/client";
import Datepicker from "@vuepic/vue-datepicker";
import { formatDate } from "@/helpers/HelperTool";
import moment from "moment";

@Component({
  components: { Datepicker },
})
class FaultyProductItem extends Vue {
  @Prop({ default: null })
  productData!: ProductInformation[];
}

export default FaultyProductItem;
</script>
